import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const RequestsApi = createApi({
  reducerPath: "Requests",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllRequests: builder.query({
      query: (val) => {
        const page = val.page ?? 1;
        const limit = val.limit ?? 10;
        const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
        const order = val.order ? `&order=${val.order}` : "";
        const search = val.search ? `&search=${val.search}` : "";
        const queryString = val.queryString
          ? `&${val.queryString.substring(1)}`
          : "";
        return `/service-requests?page=${page}&limit=${limit}${search}${sortBy}${order}${queryString}`;
      },
    }),
    getSpecificRequest: builder.query({
      query: (id) => `/service-requests/${id}`,
    }),
    cancelRequest: builder.mutation({
      query: (id) => ({
        url: `/service-requests/cancel/${id}`,
        method: "PUT",
      }),
    }),
    deleteRequest: builder.mutation({
      query: (id) => ({
        url: `/service-requests/${id}`,
        method: "DELETE",
      }),
    }),
    createRequest: builder.mutation({
      query: (payload) => ({
        url: "/service-requests/create",
        method: "POST",
        body: payload,
      }),
    }),
    editRequest: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/service-requests/edit/${id}`,
        method: "PUT",
        body: payload,
      }),
    }),
    getRequestsByStatus: builder.query({
      query: ({ status, val }) =>
        `/service-requests/reports/${status}?page=${val.page}&limit=${
          val.limit
        }${val.sortby ? `&sortBy=${val.sortby}` : ""}${
          val.search ? `&search=${val.search}` : ""
        }${val.fromDate ? `&fromDate=${val.fromDate}` : ""}${
          val.toDate ? `&toDate=${val.toDate}` : ""
        }`,
    }),
  }),
});

export const {
  useGetAllRequestsQuery,
  useCancelRequestMutation,
  useDeleteRequestMutation,
  useGetSpecificRequestQuery,
  useCreateRequestMutation,
  useEditRequestMutation,
  useGetRequestsByStatusQuery,
} = RequestsApi;
